import { Component, Input, OnInit } from '@angular/core';
import { UserRole } from "@core/models/Enums/UserRole";
import { UnsubscribeOnDestroyAdapter } from "@shared";
import { Statistics } from "@core/models/Statistics";
import { AuthManagementService } from "@core/service/auth-management.service";
import { GeneralService } from "@core/http/general.service";
import { BusinessGroupService } from "@core/service/business-group.service";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { environment } from '@enviroment/environment';

@Component({
  selector: 'app-top-widgets',
  standalone: true,
  imports: [],
  templateUrl: './top-widgets.component.html',
  styleUrl: './top-widgets.component.scss'
})
export class TopWidgetsComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {

  @Input() control: string = 'self';

  statistics: Statistics = new Statistics({} as Statistics);
  businessGroupId: string | null = null;
  protected readonly UserRole = UserRole;

  currentRegion: string = '';

  constructor(
    private authManagement: AuthManagementService,
    private generalService: GeneralService,
    private businessGroupService: BusinessGroupService,
    private router: Router,
    public httpClient: HttpClient,
    public dialog: MatDialog,
  ) {
    super();
  }

  ngOnInit() {
    const userData = this.authManagement.userData();

    this.currentRegion = String(environment.region ?? '').trim().toUpperCase();

    this.subs.sink = this.businessGroupService.businessGroupId$.subscribe((id) => {
      this.businessGroupId = id ?? null;
    });

    this.statistics.userRole = userData?.TipoUsuario;
  }

  private isSpainRegion(): boolean {
    return this.currentRegion === 'ES';
  }

  public canShowCreateUser(): boolean {
    if (this.isSpainRegion()) {
      return false;
    }

    const role = this.statistics.userRole;

    return (
      role === UserRole.Admin ||
      role === UserRole.Supervisor_Sucursales ||
      role === UserRole.Responsable_Farmacia
    );
  }

  public canShowCreateDoctor(): boolean {
    const role = this.statistics.userRole;

    return (
      role === UserRole.Admin ||
      role === UserRole.Supervisor_Sucursales ||
      role === UserRole.Responsable_Farmacia
    );
  }

  public canShowCreateBranch(): boolean {
    const role = this.statistics.userRole;

    return (
      role === UserRole.Admin ||
      role === UserRole.Supervisor_Sucursales
    );
  }

  public canShowCreateSupply(): boolean {
    if (this.isSpainRegion()) {
      return false;
    }

    const role = this.statistics.userRole;

    return (
      role === UserRole.Admin ||
      role === UserRole.Supervisor_Sucursales ||
      role === UserRole.Responsable_Farmacia
    );
  }

  public canShowCreatePatient(): boolean {
    const role = this.statistics.userRole;

    return (
      role === UserRole.Medico ||
      role === UserRole.Particular
    );
  }

  public canShowCreatePrescription(): boolean {
    const role = this.statistics.userRole;

    return (
      role === UserRole.Medico ||
      role === UserRole.Particular
    );
  }

  public canShowCreateHealthEvent(): boolean {
    return this.statistics.userRole === UserRole.Paciente;
  }

  onCreatePatient() {
    this.router.navigate(['patient/create-edit']).then();
  }

  onCreateDoctor() {
    this.router.navigate(['doctor/create-edit']).then();
  }

  onCreatePrescription() {
    this.router.navigate(['/prescription/create']).then();
  }

  onCreateSupply() {
    this.router.navigate(['prescription/prescription-supply']).then();
  }

  onCreateUser() {
    if (!this.canShowCreateUser()) {
      return;
    }

    this.router.navigate(['/admin/create-edit']).then();
  }

  onCreateBranch() {
    if (!this.businessGroupId) {
      return;
    }

    const businessGroupId = btoa(this.businessGroupId);
    this.router.navigate(['branch/create-edit/' + businessGroupId]).then();
  }

  onNuevoEventoClick() {
    this.router.navigate(['/patient/health-event-list'], { queryParams: { nuevo: 'true' } }).then();
  }
}
